var map = {
	"./icon-app.png": "826c1",
	"./icon-assmessment.png": "c76e",
	"./icon-auto-play.png": "3d64",
	"./icon-empty.png": "d0fb",
	"./icon-next.png": "6fa0",
	"./icon-notes.png": "e4917",
	"./icon-other.png": "7b8f",
	"./icon-photo-rule.png": "3dc8",
	"./icon-reviews.png": "19b2",
	"./icon-service-rule.png": "06ad",
	"./icon-stop-play.png": "8f4f",
	"./icon-voice.png": "f052",
	"./icon-weather.png": "e80c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33e5";